import l from "./_arity.mjs";
import g from "./_isPlaceholder.mjs";
function e(m, a, f) {
  return function() {
    for (var o = [], t = 0, i = m, r = 0; r < a.length || t < arguments.length; ) {
      var n;
      r < a.length && (!g(a[r]) || t >= arguments.length) ? n = a[r] : (n = arguments[t], t += 1), o[r] = n, g(n) || (i -= 1), r += 1;
    }
    return i <= 0 ? f.apply(this, o) : l(i, e(m, o, f));
  };
}
export {
  e as default
};
